'use client'

import { FC, useEffect, useState } from 'react'

import cx from 'classnames'
import styles from './styles.module.scss'

import { Colour } from '@/components/constants/colours'
import { SectionPaddingDefault } from '@/components/constants'
import { CmsAsset } from '../PageHero'
import { CmsPageSectionBase } from '@/components/ComposedPage/types'
import { Panel, PanelItem, PanelLayout } from '@/components/Panel'
import { Video } from '@/components/Video/Video'

export interface CmsEmbeddedVideoSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    title?: string
    bodyCopy?: string
    backgroundColour: Colour
    video?: CmsAsset
    poster?: CmsAsset
    mobileVideo?: CmsAsset
    mobileVideoPoster?: CmsAsset
  }
}

export const EmbeddedVideoSection: FC<CmsEmbeddedVideoSection> = ({
  fields,
}) => {
  const {
    title,
    bodyCopy,
    video,
    poster,
    backgroundColour = Colour.warmStone,
    sectionPaddingBottom,
    sectionPaddingTop,
    mobileVideo,
    mobileVideoPoster,
  } = fields
  const [played, setPlayed] = useState(false)

  useEffect(() => {
    const setClicked = () => setPlayed(false)

    window.addEventListener('resize', setClicked)

    return () => window.removeEventListener('resize', setClicked)
  }, [])

  return (
    <Panel
      layout={PanelLayout.full}
      colour={Colour[backgroundColour]}
      className={styles.embeddedVideoSection}
      short
    >
      <PanelItem
        className={cx(
          styles.item,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
        )}
      >
        {(title || bodyCopy) && (
          <div data-testid="copy" className={styles.copy}>
            {title && <h4 className={styles.title}>{title}</h4>}
            {bodyCopy && (
              <p className={styles.bodyCopy} data-testid="copy">
                {bodyCopy}
              </p>
            )}
          </div>
        )}
        {video && (
          <div
            data-testid="container"
            className={cx(styles.videoContent, { [styles.played]: played })}
            onClick={() => {
              setPlayed(true)
            }}
          >
            <Video
              className={cx(styles.video)}
              video={video}
              videoPoster={poster}
              mobileVideo={mobileVideo}
              mobileVideoPoster={mobileVideoPoster}
              play={played}
            />
          </div>
        )}
      </PanelItem>
    </Panel>
  )
}
